import { HTTP_GET, HTTP_POST, HTTP_PUT, WebApiRequest } from "tools/webservice";
import { Ref } from "react";
import { GenerateErrorReportRequest, PhoenixFormDetail, PhoenixFormDetailEdit, PhoenixFormListItem } from "interfaces/Mueller.Business.Models";
import buildQueryString from "components/Utility/buildQueryString";
import { CreateFormDefinitionRequest, FormDefinition, FormDefinitionCopyRequest, FormDefinitionValidateResponse, XPathEvaluateRequest, XPathEvaluateResponse } from "interfaces/Phoenix.FormsDesigner.Models";

export const getAllForms = (controlIdNumber: number, successCallback: (data: any) => void, errorCallback: () => void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/phoenixforms/${controlIdNumber}`,
  successCallback,
  errorCallback,
  mountedRef,
  disableDefaultErrorResponseHandler: true,
});

export const getDesignerFormsList = (params: { includeInactive: boolean, customerNumber: number }, successCallback: (data: PhoenixFormListItem[]) => void, mountedRef: Ref<boolean>) => {
  return WebApiRequest({
    method: HTTP_GET,
    endpoint: buildQueryString("/phoenixforms-list/forms", params),
    successCallback,
    mountedRef,
  });
};

export const getFormDetails = (phoenixFormIdOrAvailFormId: string, successCallback: (data: PhoenixFormDetail) => void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/phoenixforms-list/forms/${phoenixFormIdOrAvailFormId}`,
  successCallback,
  mountedRef,
});

export const saveFormDetails = (phoenixFormIdOrAvailFormId: string, details: Partial<PhoenixFormDetailEdit>, successCallback: (data: PhoenixFormDetail) => void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/phoenixforms-list/forms/${phoenixFormIdOrAvailFormId}`,
  payload: details,
  successCallback,
  mountedRef,
});

export const getFormPreview = (phoenixFormId: string, successCallback: (json: string) => void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/phoenixforms-list/preview/${phoenixFormId}`,
  successCallback,
  mountedRef,
});

export const getSharedFormPreview = (phoenixFormId: string, successCallback: (json: string) => void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/phoenixforms-list/shared-preview/${phoenixFormId}`,
  successCallback,
  mountedRef,
});

export const generateErrorReport = (request: GenerateErrorReportRequest, successCallback: () => void, errorCallback: () => void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/phoenixforms-list/error-report`,
  payload: request,
  successCallback,
  errorCallback,
  mountedRef,
});

export const createFormDefinition = (formDef: CreateFormDefinitionRequest, successCallback: (formDef: FormDefinition) => void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_POST,
  payload: formDef,
  endpoint: `/phoenixforms-designer/forms`,
  successCallback,
  mountedRef,
});

export const copyFormDefinition = (phoenixFormId: string, formDef: FormDefinitionCopyRequest, successCallback: (formDef: FormDefinition) => void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_POST,
  payload: formDef,
  endpoint: `/phoenixforms-designer/forms/${phoenixFormId}/copy`,
  successCallback,
  mountedRef,
});

export const getFormDefinition = (phoenixFormId: string, successCallback: (formDef: FormDefinition) => void, errorCallback: () => void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/phoenixforms-designer/forms/${phoenixFormId}/definition`,
  successCallback,
  errorCallback,
  mountedRef,
});

export const updateFormDefinition = (phoenixFormId: string, formDef: FormDefinition, successCallback: (formDef: FormDefinition) => void, errorCallback: () => void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_PUT,
  payload: formDef,
  endpoint: `/phoenixforms-designer/forms/${phoenixFormId}`,
  successCallback,
  errorCallback,
  mountedRef,
});

export const evaluateXPath = (payload: Omit<XPathEvaluateRequest, "token">, successCallback: (response: XPathEvaluateResponse) => void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_POST,
  payload: payload,
  endpoint: `/phoenixforms-designer/forms/evaluate-xpath`,
  successCallback,
  mountedRef,
});

export const validateFormDefinition = (phoenixFormId: string, successCallback: (formDef: FormDefinitionValidateResponse) => void, errorCallback: () => void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/phoenixforms-designer/forms/${phoenixFormId}/validate`,
  successCallback,
  errorCallback,
  mountedRef,
});

export const validateFormDefinitionExportId = (phoenixFormId: string, successCallback: (formDef: FormDefinitionValidateResponse) => void, errorCallback: () => void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/phoenixforms-designer/forms/${phoenixFormId}/validate/export-id`,
  successCallback,
  errorCallback,
  mountedRef,
});

export const generateDataModel = (phoenixFormId: string, successCallback: (formDef: FormDefinition) => void, errorCallback: () => void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/phoenixforms-designer/forms/${phoenixFormId}/generated-xml`,
  successCallback,
  errorCallback,
  mountedRef,
});

export const updateDataModel = (phoenixFormId: string, successCallback: (formDef: FormDefinition) => void, errorCallback: () => void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/phoenixforms-designer/forms/${phoenixFormId}/updated-xml`,
  successCallback,
  errorCallback,
  mountedRef,
});
